import $ from "jquery";
import ko from "knockout";
import metaCache from "flow/utils/metaCache";
import "flow/bindings/elementHandleBinding";
import template from "./logoUpload.html";
import { MaybeObservable, MaybeObservableArray } from "flow/interfaces/MaybeObservable";

export interface ILogoUploadParams {
    maxFileSize: MaybeObservable<number>;
    allowedFileTypes: MaybeObservableArray<string>;
    imageUrl: string | ArrayBuffer | KnockoutObservable<string | ArrayBuffer>;
    selectImageButtonText: MaybeObservableArray<string>;
    isValid: KnockoutObservable<boolean>;
}

ko.components.register("ko-logoupload", {
    viewModel: function (params: ILogoUploadParams) {
        const maxFileSize = ko.isObservable(params.maxFileSize)
            ? params.maxFileSize
            : ko.observable(params.maxFileSize);
        const allowedFileTypes = ko.isObservable(params.allowedFileTypes)
            ? params.allowedFileTypes
            : ko.observableArray(params.allowedFileTypes);
        const imageUrl = ko.isObservable(params.imageUrl) ? params.imageUrl : ko.observable(params.imageUrl);
        const selectImageButtonText = ko.isObservable(params.selectImageButtonText)
            ? params.selectImageButtonText
            : ko.observable(params.selectImageButtonText);
        const isValid = ko.observable(false);
        let inputControl: HTMLInputElement;
        const invalidImage = ko.observable();

        const handleFileSelect = function (evt: any) {
            const file = evt.target.files[0];
            const reader = new FileReader();

            reader.onload = function () {
                isValid(false);
                const imageFileContent = reader.result;
                if (allowedFileTypes().indexOf(file["type"]) < 0) {
                    invalidImage(
                        metaCache.lookup(
                            "FlowHtml.Translations.InvalidImageFormat",
                            "FlowHtml.Translations.InvalidImageFormat"
                        ) +
                            ", " +
                            metaCache.lookup(
                                "EC.HousingWeb.Translations.AllowedImageTypes",
                                "EC.HousingWeb.Translations.AllowedImageTypes"
                            ) +
                            ":  [" +
                            allowedFileTypes().join(", ") +
                            "]"
                    );
                    isValid(false);
                    imageUrl("");
                } else if (file.size > maxFileSize()) {
                    invalidImage(
                        metaCache.lookup(
                            "FlowHtml.Translations.MaxFileSizeExceedsLimit",
                            "FlowHtml.Translations.MaxFileSizeExceedsLimit"
                        ) +
                            " " +
                            maxFileSize() / 1024 +
                            "KB"
                    );
                    isValid(false);
                    imageUrl("");
                } else {
                    invalidImage(null);
                    isValid(true);
                    imageUrl(imageFileContent);
                }
            };

            if (file) {
                reader.readAsDataURL(file);
            }
        };

        params.isValid = isValid;

        const setElement = function (element: HTMLInputElement) {
            inputControl = element;
        };

        const onAddAttachment = function () {
            $(inputControl).trigger("click");
        };

        return {
            maxFileSize: maxFileSize,
            allowedFileTypes: allowedFileTypes,
            invalidImage: invalidImage,
            selectImageButtonText: selectImageButtonText,
            onAddAttachment: onAddAttachment,
            isValid: isValid,
            imageUrl: imageUrl,
            handleFileSelect: handleFileSelect,
            setElement: setElement
        };
    },
    template: template,
    synchronous: true
});
